import { unavailableOnWeb } from './unavailableOnWeb.web';
/**
 * Web stub for `react-native-blob-util`, which has no web implementation.
 */
const RNBlobUtil = {
    config: unavailableOnWeb('RNBlobUtil.config'),
    fetch: unavailableOnWeb('RNBlobUtil.fetch'),
    wrap: unavailableOnWeb('RNBlobUtil.wrap'),
    fs: {
        dirs: {},
        stat: unavailableOnWeb('RNBlobUtil.fs.stat'),
        unlink: unavailableOnWeb('RNBlobUtil.fs.unlink'),
    },
    MediaCollection: {
        copyToInternal: unavailableOnWeb('RNBlobUtil.MediaCollection.copyToInternal'),
    },
    android: {
        actionViewIntent: unavailableOnWeb('RNBlobUtil.android.actionViewIntent'),
    },
};
export default RNBlobUtil;
